import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {
  ControlContainer,
  FormBuilder,
  FormGroup,
  NgForm,
  Validators
} from '@angular/forms';
import {
  ILabReq,
  LabReqField,
  LabReqTestElement
} from '@care-portals/api-interfaces';

@Component({
  selector: 'my-health-admin-lab-requisition-element',
  templateUrl: './lab-requisition-element.component.html',
  styleUrls: ['./lab-requisition-element.component.less'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class LabRequisitionElementComponent implements OnInit, AfterViewInit {
  @ViewChild('ngForm', { static: true }) private ngForm: NgForm;
  @Output() valueChanged: EventEmitter<object> = new EventEmitter();
  @Input() parentId: string;
  @Input() element: LabReqTestElement;
  @Input() labReq: ILabReq;
  fields: Array<LabReqField> = [];
  form: FormGroup;

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.element.children.forEach((child, index) => {
      this.fields.push({
        id: this.parentId + '_' + child.id,
        label: child.label,
        type: child.type,
        required: child.required ?? false,
        level: !index ? 'child' : undefined
      });
    });

    const groupItems = {};
    this.fields.forEach(field => {
      if (field.type !== 'divider') {
        Object.assign(groupItems, {
          [field.id]: [
            field.type === 'string' ? '' : field.type === 'number' ? 0 : null,
            field.required ? Validators.required : null
          ]
        });
      }
    });

    this.form = this.formBuilder.group(groupItems);
    if (this.labReq) {
      this.form.patchValue(this.labReq.data);
    }
  }

  ngAfterViewInit(): void {
    this.ngForm.valueChanges.subscribe(values => {
      this.valueChanged.emit(values);
    });
  }

  checkValidate() {
    Object.values(this.form.controls).forEach(control => {
      if (control.invalid) {
        control.markAsDirty();
        control.updateValueAndValidity({ onlySelf: true });
      }
    });
    return this.form.valid;
  }
}
